import { Component, deps, inject, observer } from '../../lib/component';
import { classes, style } from 'typestyle';
import { SVGIcon } from '../svg-icon';
import {
  colorContrast,
  colorDarkBlueGrey,
  colorFavouriteHover,
  colorSlate,
} from '../../theme/color';
import { ButtonPill } from '../button-pill';
import React from 'react';
import { px } from 'csx';
import { transitionQuickEase } from '../../theme/transition';
import { animationPulse } from '../../theme/animation';

const styles = {
  icon: style({
    $nest: {
      '& path': {
        stroke: colorSlate.toString(),
        fill: colorSlate.toString(),
      },
      '&.selected path': {
        stroke: colorContrast.toHexString(),
        fill: colorContrast.toHexString(),
        transition: `stroke ${transitionQuickEase}, fill ${transitionQuickEase}`,
      },
      ':hover > &.selected path': {
        stroke: colorFavouriteHover.toHexString(),
        fill: colorFavouriteHover.toHexString(),
      },
    },
  }),
  iconLoading: style({
    $nest: {
      '& path': {
        ...animationPulse,
      },
    },
  }),
};

export interface FavouritePlaylistButtonCompatProps {
  className?: string;
  identity: string;
}

@inject(deps)
@observer
export default class FavouritePlaylistButtonCompat extends Component<FavouritePlaylistButtonCompatProps> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  get isFavourite() {
    return this.props.model.playlist.favouritePlaylists.includes(this.props.identity);
  }

  async handleFavourite() {
    const { model, controller } = this.props;
    const { user } = model;
    const { playlist, onboarding } = controller;
    if (this.state.loading) return;
    if (!user.user) return onboarding.openSignUpModal();
    const toggleFavourite = this.isFavourite ? playlist.unfavouritePlaylist : playlist.favouritePlaylist;
    this.setState({
      loading: true,
    });
    const response = await toggleFavourite.call(playlist, this.props.identity);
    this.setState({
      loading: false,
    });
    return response;
  }

  render() {
    const { className } = this.props;
    const { loading } = this.state;

    return (
      <ButtonPill
        tertiary
        icon
        className={classes(className, loading && styles.iconLoading)}
        disabled={loading}
        onClick={this.handleFavourite.bind(this)}
      >
        <SVGIcon.Favourite
          className={classes(styles.icon, this.isFavourite && 'selected')}
          color={colorDarkBlueGrey.toHexString()}
          size={10}
        />
      </ButtonPill>
    );
  }
}
